import React, {
  useState,
  VFC,
  FocusEvent,
  ChangeEvent,
  useEffect,
  useCallback,
} from "react";

import {IReduxState} from "../../../ReduxImpl/reducers/index";
import {
  UpdateConditionalFieldValue,
  updateCustomError,
} from "../../../ReduxImpl/actions/index";
import {useDispatch, useSelector} from "react-redux";

const BaseTextField = (props) => {
  const {field, type, tracker} = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [value, setValue] = useState(props.value);
  const hasValueOrFocus = hasFocus || value !== "";
  const hasAnyError = !!props.errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const emailRegex = /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const removeError = useSelector((state: IReduxState) => state.removeError);
  const customError = useSelector((state: IReduxState) => state.customError);
  const hasCustomError = !!customError;
  const fieldValues = useSelector((state: IReduxState) => state.fieldValues);
  const fields = useSelector((state: IReduxState) => state.fields);
  const dispatch = useDispatch();
  // const [errorCount, setErrorCount] = useState(0)
  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value);
    setHasFocus(true);
    if (removeError) {
      // setErrorCount(1)
      dispatch(updateCustomError(""));
    }
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value);
    setHasFocus(false);
  };
  // useEffect(() => {
  //   if (type === 'email' && value !== '') {
  //     if (
  //       fields.fields?.[1]?.fields?.[0].fields?.[2]?.fields?.[1]?.fields?.[2]
  //         ?.model?.name === 'Email Confirmation'
  //     ) {
  //       let emailField =
  //         fields?.fields?.[1]?.fields?.[0].fields?.[2]?.fields?.[1]
  //           ?.fields?.[2];
  //       if (
  //         fieldValues[field.model['conditionSettings']?.fieldKey] ===
  //         fieldValues[emailField?.model['conditionSettings']?.fieldKey]
  //       ) {
  //         props.onChange(
  //           emailField.valueField.name,
  //           fieldValues[emailField?.model['conditionSettings']?.fieldKey],
  //           props.isValid,
  //           []
  //         );
  //       } else {
  //         props.onChange(
  //           emailField.valueField.name,
  //           fieldValues[emailField?.model['conditionSettings']?.fieldKey],
  //           props.isValid,
  //           ['The emails are different']
  //         );
  //       }
  //     }
  //   }
  // }, [fieldValues, value]);

  const fromClassNameToEmailInput: (_className: string) => HTMLInputElement =
    useCallback(
      (_className) =>
        document
          ?.getElementsByClassName(_className)?.[0]
          ?.getElementsByTagName("input")?.[0],
      []
    );

  const findOtherEmailInput: (
    target: ChangeEvent<HTMLInputElement>["target"]
  ) => {
    cssClass: "EmailSection" | "ConfirmEmailSection" | "";
    otherInput: HTMLInputElement;
  } = useCallback((target) => {
    const cssClass = target?.parentElement?.parentElement?.parentElement
      ?.classList[0] as "EmailSection" | "ConfirmEmailSection";
    if (cssClass)
      switch (cssClass) {
        case "EmailSection": {
          return {
            cssClass,
            otherInput: fromClassNameToEmailInput("ConfirmEmailSection"),
          };
        }
        case "ConfirmEmailSection": {
          return {
            cssClass,
            otherInput: fromClassNameToEmailInput("EmailSection"),
          };
        }
      }
    if (typeof document != "undefined") {
      let empty = document.createElement("input");
      empty.value = "";
      empty.name = "";
      return {
        cssClass: "",
        otherInput: document.createElement("input"),
      };
    }
  }, []);

  const onChange: (e: ChangeEvent<HTMLInputElement>) => void = ({target}) => {
    const {value: newValue, type: targetType} = target;

    document.getElementById(id).classList.remove("error");
    // ----- 🥵 EMAIL VALIDATION 🥵 -----
    // if type is email ->
    if (targetType == "email") {
      // -> first check that regex is ok
      if (newValue.match(emailRegex) && newValue) {
        console.log("match");
        // -> then find out other email input name and value
        const {
          cssClass,
          otherInput: {value: otherInputValue, name: otherInputName},
        } = findOtherEmailInput(target);

        // -> trigger onChange, setting email verification field error if necessary
        const errorList = ["Emails do not match"];
        if (cssClass !== "") {
          if (
            newValue !== otherInputValue &&
            otherInputValue.match(emailRegex)
          ) {
            // -> if current field is main email input, also trigger onChange for verification input
            // 		to show error underneath, without modifying its value
            if (cssClass === "EmailSection") {
              props.onChange(otherInputName, otherInputValue, true, errorList);
              props.onChange(
                field.valueField.name,
                newValue,
                props.isValid,
                []
              );
            } else {
              // -> if current field is verification email input, trigger onChange with error
              props.onChange(
                field.valueField.name,
                newValue,
                props.isValid,
                errorList
              );
            }
          } else {
            // if no error is detected trigger onChange normally and also make sure that
            // no previous error under verification input persists
            props.onChange(field.valueField.name, newValue, props.isValid, []);
            if (
              cssClass === "EmailSection" &&
              otherInputValue.match(emailRegex)
            ) {
              props.onChange(otherInputName, otherInputValue, true, []);
            }
          }
        } else {
          props.onChange(field.valueField.name, newValue, props.isValid, []);
        }
        // -> display error only if other input also has a valid email
      } else {
        setHasFocus(true);

        props.onChange(field.valueField.name, newValue, props.isValid, [
          "Invalid email address",
        ]);
      }
    } else if (targetType === "number" && props?.field?.model?.max) {
      if (newValue?.length > props?.field?.model?.max) {
        return;
      } else {
        props.onChange(field.valueField.name, newValue, props.isValid, []);
      }
    } else {
      props.onChange(field.valueField.name, newValue, props.isValid, []);
    }

    setValue(newValue);

    fieldValues[field?.model?.["conditionSettings"]?.fieldKey] = newValue;
    dispatch(UpdateConditionalFieldValue(fieldValues));
    // dispatch(removeError(!removeError))
  };
  // [props, fieldValues, dispatch, setValue, setHasFocus]

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? "sitecore-jss-form__control--has-error" : ""
      } ${
        field.model.name === "EmailText"
          ? "sitecore-jss-form__control--emailTextbox"
          : ""
      } ${
        field.model.name === "CompanyName"
          ? "sitecore-jss-form__control--companyName"
          : ""
      }
 `}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? "sitecore-jss-form__label--has-focus" : ""
        }  `}
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        className={`sitecore-jss-form__field`}
        type={type}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={props.value}
      />
      {field.model.name === "EmailText" && removeError && hasCustomError ? (
        <div className="sitecore-jss-form__error-list error">
          <pfe-icon
            icon="ivg-alert-triangle-line"
            size="14"
            className="sitecore-jss-form__error-list__icon PFElement"
          ></pfe-icon>
          <span>&nbsp; {customError}</span>
        </div>
      ) : (
        ""
      )}

      <FieldValidationErrors {...props} />
    </div>
  );
};

export default BaseTextField;
